module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr9-769e69930de87237e9832b2d5b20a147.jpg";